export default __webpack_public_path__ + "static/media/visita_b_eng.db938338.png";